exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail .el-col[data-v-28664076] {\n  line-height: 36px;\n}\n.detail .el-col span[data-v-28664076]:nth-child(1) {\n  padding-right: 12px;\n  color: #000;\n}\n.detail[data-v-28664076] .el-dialog__body {\n  padding-bottom: 0;\n}\n.detail .detailList[data-v-28664076] {\n  max-height: 540px;\n  overflow-y: auto;\n}\n", ""]);

// exports
